import { render } from "./vordergoods.vue?vue&type=template&id=f5a35f7c&scoped=true"
import script from "./vordergoods.vue?vue&type=script&lang=js"
export * from "./vordergoods.vue?vue&type=script&lang=js"

import "./vordergoods.vue?vue&type=style&index=0&id=f5a35f7c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5a35f7c"]])

export default __exports__